import React, { useEffect, useState } from "react";
import { db } from '../firebase/firebase';
import { ref, onValue } from 'firebase/database';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useTranslation } from "react-i18next";


function extractPreviewData(htmlContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");

    const image = doc.querySelector('img'); // Gets the first <img> element
    const header = doc.querySelector('h1'); // Gets the first <h1> element

    return {
        imageUrl: image ? image.src : null,
        headerText: header ? header.innerText : "No Title"
    };
}

export default function AllPosts() {
    const { t, i18n } = useTranslation()
    const navigate = useNavigate()
    useEffect(() => {
        document.body.className = '';
        document.body.classList.add('blog');
    }, [])

    const [posts, setPosts] = useState([]);
    const [postsAr, setPostsAr] = useState([]);

    useEffect(() => {
        const postsRef = ref(db, 'posts/en');
        const postsRefAr = ref(db, 'posts/ar');
        onValue(postsRef, (snapshot) => {
            const data = snapshot.val();
            const loadedPosts = [];
            if (data) {
                Object.keys(data).forEach(key => {
                    const previewData = extractPreviewData(data[key].content);
                    loadedPosts.push({
                        id: key,
                        content: data[key].content,
                        headerText: data[key].postTitle,
                        imageUrl: data[key].imgPreview,
                        timestamp: new Date(data[key].timestamp).toLocaleString()
                    });
                });
            }
            setPosts(loadedPosts.reverse());
        });

        onValue(postsRefAr, (snapshot) => {
            const data = snapshot.val();
            const loadedPosts = [];
            if (data) {
                Object.keys(data).forEach(key => {
                    const previewData = extractPreviewData(data[key].content);
                    loadedPosts.push({
                        id: key,
                        content: data[key].content,
                        headerText: data[key].postTitle,
                        imageUrl: data[key].imgPreview,
                        timestamp: new Date(data[key].timestamp).toLocaleString()
                    });
                });
            }
            setPostsAr(loadedPosts.reverse());
        });
    }, []);
    return (
        <div className="p-4">
            <div className="w-full flex flex-col lg:flex-row gap-[20px] justify-start flex-wrap">
                {i18n.language === 'en' ? posts.map((post) => (
                    <div onClick={() => navigate(`/blog/${post.id}`)} style={{width: window.innerWidth > 1024 ? `${(window.innerWidth / 4) - 30}px` : `${(window.innerWidth / 1) - 40}px`}} className="cursor-pointer border-[1px] border-[#d0a645] rounded-[20px] overflow-hidden">
                        <img src={post.imageUrl} className="h-[350px] w-full" alt="" />
                        <div className="h-[200px] p-[20px] flex flex-col gap-[20px]">
                            <h1 className="text-xl lg:text-2xl 2xl:text-3xl uppercase">{`${post.headerText.slice(0, 30)}...`}</h1>
                            <h2 className="text-end uppercase underline">{t('read')}
                                <span>{i18n.language === 'en' ? <ArrowForward /> : <ArrowBack />}</span>
                            </h2>
                        </div>
                    </div>
                )) :
                    postsAr.map((post) => (
                        <div onClick={() => navigate(`/blog/${post.id}`)}  style={{width: window.innerWidth > 1024 ? `${(window.innerWidth / 4) - 30}px` : `${(window.innerWidth / 1) - 40}px`}} className="cursor-pointer border-[1px] border-[#d0a645] rounded-[20px] overflow-hidden">
                            <img src={post.imageUrl} className="h-[350px] w-full" alt="" />
                            <div className="h-[200px] p-[20px] flex flex-col gap-[20px]">
                                <h1 className="text-xl lg:text-2xl 2xl:text-3xl uppercase">{`${post.headerText.slice(0, 30)}...`}</h1>
                                <h2 className="text-end uppercase underline">{t('read')}
                                    <span>{i18n.language === 'en' ? <ArrowForward /> : <ArrowBack />}</span>
                                </h2>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    )
}